import * as React from "react";

import Plot from "react-plotly.js";

interface ChartProps {
    data: any;
    width?: number;
    height?: number;
}

const StatisticsPieChartClassesByYear = (props: ChartProps) => {
    if (props.data["name"] != "" && props.data["values"].length && props.data["labels"].length && props.data["values"].length == props.data["labels"].length)
        return (
            <Plot
                data={[
                    { type: 'pie', values: props.data["values"], labels: props.data["labels"], direction: "clockwise", sort: false },
                ]}
                layout={{ width: props.width || 500, height: props.height || 500, title: "Počty tříd v roce " + props.data["year"] + " - " + props.data["type"] }}
            />
        );
    return null;
}

const StatisticsBarChartVerticalMemberQuantities = (props: ChartProps) => {
    return (
        <Plot
            data={[
                { type: 'bar', x: props.data["datasets"][0]["years"], y: props.data["datasets"][0]["values"], name: props.data["datasets"][0]["name"] },
                { type: 'bar', x: props.data["datasets"][1]["years"], y: props.data["datasets"][1]["values"], name: props.data["datasets"][1]["name"] },
                { type: 'bar', x: props.data["datasets"][2]["years"], y: props.data["datasets"][2]["values"], name: props.data["datasets"][2]["name"] },
                { type: 'bar', x: props.data["datasets"][3]["years"], y: props.data["datasets"][3]["values"], name: props.data["datasets"][3]["name"] },
            ]}
            layout={{ width: props.width || 1200, height: props.height || 500, title: "Vývoj členské základny", barmode: "group" }}
        />
    );
}

const StatisticsBarChartHorizontalMemberQuantitiesByDivision = (props: ChartProps) => {
    return (
        <Plot
            data={[
                { type: 'bar', x: props.data["datasets"][0]["values"], y: props.data["datasets"][0]["divisions"], name: props.data["datasets"][0]["name"], orientation: "h" },
                { type: 'bar', x: props.data["datasets"][1]["values"], y: props.data["datasets"][1]["divisions"], name: props.data["datasets"][1]["name"], orientation: "h" },
                { type: 'bar', x: props.data["datasets"][2]["values"], y: props.data["datasets"][2]["divisions"], name: props.data["datasets"][2]["name"], orientation: "h" },
            ]}
            layout={{ width: props.width || 1200, height: props.height || 1000, title: "Počty členů v divizích v roce " + props.data["year"], barmode: "group", xaxis: { tickangle: -90 }, margin: { l: 250, pad: 20 } }}
        />
    );
}






export {
    StatisticsPieChartClassesByYear,
    StatisticsBarChartVerticalMemberQuantities,
    StatisticsBarChartHorizontalMemberQuantitiesByDivision
}